<template>
  <Page class="queryView">
    <div class="queryView-main">
      <a-form
        class="flex-form"
        style="flex: 1"
        layout="inline"
        :labelCol="{
          span: 5,
        }"
        :wrapperCol="{
          span: 18,
        }"
        :form="form"
        :colon="false"
      >
        <a-row>
          <a-col :span="6">
            <a-form-item label="订单号">
              <a-input
                :max-length="64"
                allow-clear
                v-model="form.orderNo"
                placeholder="请输入订单号"
                @pressEnter="doQuery(1)"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="产品名称">
              <a-input
                :max-length="64"
                allow-clear
                v-model="form.travelName"
                placeholder="请输入产品名称"
                @pressEnter="doQuery(1)"
              ></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="出行人">
              <a-input
                :max-length="64"
                allow-clear
                v-model="form.applyName"
                placeholder="请输入出行人"
                @pressEnter="doQuery(1)"
              ></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :span="6">
            <a-form-item label="订单状态">
              <a-select
                class="form-control"
                :options="statusList"
                v-model="form.status"
                placeholder="请选择"
                style="width: 100%"
                allowClear
                showSearch
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="时间">
              <!-- <a-range-picker v-model="time" allowClear /> -->
              <a-month-picker v-model="time" style="width: 100%;" placeholder="请选择" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px">
          <a-col :span="24" style="text-align: right;">
            <a-button class="app-btn" type="primary" ghost style="margin-right: 20px;" @click="doQuery(1)">
              立即搜索
            </a-button>
            <a-button class="app-btn" type="default" style="margin-right: 40px;" @click="resetAndQuery">
              重置搜索
            </a-button>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        class="mt-5"
        :row-key="
          (record, index) => {
            return index
          }
        "
        bordered
        :loading="tableLoading"
        :columns="tableColumns"
        :dataSource="dataSource"
        @change="handleTableChange$qv"
        :pagination="{
          current: pageNumber,
          pageSize: pageSize,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      />
    </div>
    <a-modal
      title="退款"
      :width="900"
      v-model="refundModel"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div class="refund">
        <p class="refund-title">初始支付信息</p>
        <div class="refund-pay" v-if="payInfo">
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">支付时间:</div>
            <div class="refund-pay-item-content">{{ payInfo.payTime }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">订单号:</div>
            <div class="refund-pay-item-content">{{ order.orderId }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">支付金额:</div>
            <div class="refund-pay-item-content">{{ payInfo.amount }}</div>
          </div>
        </div>
        <div class="refund-pay" v-for="(refund, index) in refundInfo" :key="index">
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">退款时间:</div>
            <div class="refund-pay-item-content">{{ refund.payTime }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">订单号:</div>
            <div class="refund-pay-item-content">{{ order.orderId }}</div>
          </div>
          <div class="refund-pay-item">
            <div class="refund-pay-item-title">退款金额:</div>
            <div class="refund-pay-item-content">{{ refund.amount }}</div>
          </div>
        </div>
        <p class="refund-title">退款金额</p>
        <div class="refund-amount">
          <a-checkbox-group v-model="checkedList" @change="onChange" class="refund-checkbox-group">
            <div
              style="width: 80px;display: flex;margin-right: 20px;"
              v-for="(item, index) in order.travelOrderDetailList"
              :key="index"
            >
              <a-checkbox :value="item.id" :disabled="item.refundTime">{{ item.nameCn }}</a-checkbox>
            </div>
          </a-checkbox-group>
          <div class="refund-amount-item">
            退款金额
            <a-input-number
              v-model="refundAmount"
              :min="1"
              :max="Number(order.orderPayAmount) - Number(order.refundAmount)"
              placeholder="请输入退款金额"
              style="width: 200px;margin:0 10px"
            />
            可退金额 {{ Number(order.orderPayAmount) - Number(order.refundAmount) }}
          </div>
        </div>
        <a-divider />
        <p class="refund-title">退款备注</p>
        <div class="refund-remark">
          <a-textarea v-model="refundRemark" placeholder="请输入退款备注" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </div>
      </div>
    </a-modal>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  components: {
    Page,
  },
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '80px',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.pageSize * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '订单号',
        align: 'center',
        dataIndex: 'orderNo',
      },
      {
        title: '产品名称',
        width: 350,
        align: 'center',
        dataIndex: 'travelName',
      },
      {
        title: '联系人',
        align: 'center',
        dataIndex: 'contactName',
      },
      {
        title: '联系电话',
        align: 'center',
        dataIndex: 'contactMobile',
      },
      {
        title: '订单状态',
        align: 'center',
        width: '120px',
        dataIndex: 'status',
        customRender: (text, row) => {
          return <span>{this.getStatus(text)}</span>
        },
      },
      {
        title: '下单时间',
        align: 'center',
        width: '200px',
        dataIndex: 'orderTime',
      },
      {
        title: '操作',
        width: '160px',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkRow(row)
                }}
              >
                查看
              </a>
              {row.status == 30 ? (
                <a
                  class="text-primary-500"
                  onClick={() => {
                    this.handleRefund(row)
                  }}
                >
                  退款
                </a>
              ) : (
                ''
              )}
            </div>
          )
        },
      },
    ]
    return {
      pageNumber: 1,
      pageSize: 10,
      countTotal: 0,
      refundAmount: 0,
      order: {},
      payInfo: {},
      refundInfo: [],
      tableLoading: false,
      confirmLoading: false,
      refundModel: false,
      tableColumns: tableColumns,
      refundRemark: '',
      dataSource: [],
      statusList: [
        {
          value: 0,
          label: '待支付订金',
        },
        {
          value: 10,
          label: '已付订金',
        },
        {
          value: 20,
          label: '已付全款',
        },
        {
          value: -1,
          label: '取消',
        },
      ],
      checkedList: [],
      form: {
        orderId: '',
        status: '',
        productName: '',
        applyName: '',
      },
      time: '',
    }
  },
  methods: {
    getStatus(status) {
      const find = this.statusList.find(item => item.value === status)
      if (!find) return '--'
      return find.label
    },
    onChange() {},
    handleOk() {
      this.confirmLoading = true
      this.$axios
        .post('/mall/admin/travel/order/refund', {
          orderId: this.order.orderId,
          orderDetailIds: this.checkedList,
          refundAmount: this.refundAmount,
          remark: this.refundRemark,
        })
        .then(res => {
          if (res.success) {
            this.$message.success('退款成功')
            this.refundModel = false
            this.doQuery()
          }
          this.confirmLoading = false
        })
    },
    handleCancel() {
      this.refundModel = false
    },
    async checkRow(row) {
      this.$router.push({
        path: '/m/scopeMain/travelProduct/orderDetail',
        query: { orderNo: row.orderNo },
      })
    },
    async handleRefund(row) {
      this.getInfoById(row.orderId)
      this.getPayInfo(row.orderId)
      this.refundModel = true
    },
    getPayInfo(id) {
      this.$axios
        .get('/mall/admin/travel/order/payInfo', {
          params: {
            orderId: id,
          },
        })
        .then(res => {
          if (res.success) {
            this.refundInfo = res.data.refundInfo
            this.payInfo = res.data.payInfo
          }
        })
    },
    async getInfoById(id) {
      try {
        const res = await this.$axios.get(`/mall/admin/travel/order/info`, {
          params: {
            orderId: id,
          },
        })
        this.order = { ...res.data }
      } catch (e) {
        console.log(e)
      }
    },
    getParams() {
      const date = this.time ? this.time.split('-') : []
      if (date.length > 0) {
        return {
          ...this.form,
          tradeYear: date[0],
          tradeMonth: date[1],
        }
      } else {
        return {
          ...this.form,
        }
      }
    },
    async doQuery(page) {
      if (page) {
        this.pageNumber = page
      }
      this.tableLoading = true
      const res = await this.$axios.get(`/po/admin/travel/order/list`, {
        params: {
          ...this.getParams(),
          page: this.pageNumber,
          limit: this.pageSize,
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    resetAndQuery() {
      this.form.orderNo = ''
      this.form.status = ''
      this.form.travelName = ''
      this.time = ''
      this.doQuery()
    },
  },
  async mounted() {
    this.doQuery()
  },
}
</script>
<style lang="less" scoped>
.bm-view {
  height: 600px;
}
.refund {
  width: 100%;
  margin: 0 auto;
  .refund-title {
    line-height: 30px;
  }
  .refund-pay {
    width: 100%;
    min-height: 50px;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .refund-pay-item {
      display: flex;
      line-height: 30px;
      .refund-pay-item-title {
        width: 80px;
      }
    }
  }
  .refund-amount {
    width: 100%;
    min-height: 100px;
    .refund-checkbox-group {
      width: 100%;
      display: flex;
      padding: 20px;
    }
    .refund-amount-item {
      display: flex;
      line-height: 30px;
      padding: 20px;
    }
  }
  .refund-remark {
    width: 100%;
    min-height: 100px;
  }
}
</style>
